import React from "react";
import { BsChevronDown } from "react-icons/bs";
import styled from "styled-components";

// This Component is display only for now
const DropDown = (props: any) => {
  const { className, label, value } = props;
  return (
    <Wrapper className={className}>
      <p className={"label"}>{label}</p>
      <p className={"value"}>{value}</p>
      <BsChevronDown className="downArrow" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-family: HelveticaNeue-Light;
  font-size: 16px;
  color: #848991;
  display: flex;
  align-items: center;
  cursor: pointer;

  .label {
    margin-right: 28px;
  }

  .value {
    font-family: HelveticaNeue-Medium;
    margin-right: 8px;
  }
`;

export default DropDown;
